import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Privacy() {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Button 
          onClick={() => navigate('/')} 
          variant="outlined" 
          sx={{ mb: 2 }}
        >
          Back to Home
        </Button>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            Bhaktivedanta Vedic Academy ("we" or "our") collects information that you provide directly to us when you:
            • Register for our courses
            • Contact us for support
            • Subscribe to our newsletters
            • Fill out any forms on our website
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the information we collect to:
            • Provide, maintain, and improve our services
            • Send you technical notices and support messages
            • Respond to your comments and questions
            • Send you information about our courses and programs
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Information Sharing
          </Typography>
          <Typography variant="body1" paragraph>
            We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
            • With your consent
            • To comply with legal obligations
            • To protect our rights and property
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For any questions about this Privacy Policy, please contact us at:
            Bhaktivedanta Vedic Academy
            4530 Oak Shores Dr
            Plano, TX 75024-7350
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Privacy; 